module.exports = __webpack_public_path__ + "img/braille-nyomtatas.ff70bc01.jpg";